import LogoCizim from '../../../components/brand/LogoCizim';
import { logoAlt } from '../../../components/brand/markaYollari';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1f2937] text-white">
      <div id="about" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-12">
          {/* Logo & Social Media */}
          <div>
            <LogoCizim
              src="/images/logo-footer.webp"
              alt="Mahallebi"
              yol={logoAlt}
              renk="#E9B949"
              mod="gorunce"
              className="h-12 mb-6"
            />
            <p className="text-gray-400 mb-6 text-sm">
              Mahallenizdeki güvenilir komşularınızla alışverişin en kolay yolu
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/mahallebi.app"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#e77e23] transition-colors cursor-pointer"
              >
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/ubsbilisim"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#e77e23] transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Hızlı Bağlantılar</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-gray-400 hover:text-[#e77e23] transition-colors text-sm cursor-pointer"
                >
                  Özellikler
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('how-it-works')}
                  className="text-gray-400 hover:text-[#e77e23] transition-colors text-sm cursor-pointer"
                >
                  Nasıl Çalışır
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('download')}
                  className="text-gray-400 hover:text-[#e77e23] transition-colors text-sm cursor-pointer"
                >
                  İndir
                </button>
              </li>
              <li>
                <a href="/sss" className="text-gray-400 hover:text-[#e77e23] transition-colors text-sm cursor-pointer">
                  Sıkça Sorulan Sorular
                </a>
              </li>
              <li>
                <a href="/esnaf" className="text-gray-400 hover:text-[#e77e23] transition-colors text-sm cursor-pointer">
                  Mahallebi Esnafı
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Yasal</h3>
            <ul className="space-y-3">
              <li>
                <a href="/terms" className="text-gray-400 hover:text-[#e77e23] transition-colors text-sm cursor-pointer">
                  Kullanım Koşulları
                </a>
              </li>
              <li>
                <a href="/privacy" className="text-gray-400 hover:text-[#e77e23] transition-colors text-sm cursor-pointer">
                  Gizlilik Politikası
                </a>
              </li>
              <li>
                <a href="/kvkk" className="text-gray-400 hover:text-[#e77e23] transition-colors text-sm cursor-pointer">
                  KVKK
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div id="contact">
            <h3 className="text-lg font-semibold mb-4">İletişim</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-[#e77e23] mt-1"></i>
                <a
                  href="mailto:info@ubsbilisim.com"
                  className="text-gray-400 hover:text-[#e77e23] transition-colors text-sm cursor-pointer"
                >
                  info@ubsbilisim.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-global-line text-[#e77e23] mt-1"></i>
                <a
                  href="https://www.ubsbilisim.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-[#e77e23] transition-colors text-sm cursor-pointer"
                >
                  www.ubsbilisim.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-[#e77e23] mt-1"></i>
                <span className="text-gray-400 text-sm">
                  İstanbul, Türkiye
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm text-center sm:text-left">
            © 2026 Mahallebi. Tüm hakları saklıdır.
          </p>
          <p className="text-gray-500 text-xs">
            <a href="https://www.ubsbilisim.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#e77e23] transition-colors">
              UBS Bilişim
            </a> tarafından geliştirildi.
          </p>
        </div>
      </div>
    </footer>
  );
}
